import React from "react";
import "../css/SystemIntegrator.css";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { connect } from "react-redux";
import * as ActionTypes from "../actions/types";
import Loader from "./Loader";

class OtaCrashLogsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logsData: [],
      loader: true,
    };
  }

  componentDidMount() {
    this.fetchCrashLogs();
  }

  fetchCrashLogs = () => {
    this.setState({ loader: true });
    const tokenStored = `Token ${localStorage.getItem("token")}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: tokenStored,
      "X-CSRFToken": localStorage.getItem("csrftoken"),
    };

    fetch("/cloud/ota-crash-logs/", { method: "GET", headers })
      .then((response) => {
        if (response.status === 403) {
          localStorage.clear();
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          logsData: Array.isArray(data) ? data : [],
          loader: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ logsData: [], loader: false });
      });
  };

  downloadFile = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  render() {
    const { loader, logsData } = this.state;

    return (
      <React.Fragment>
        {loader && <Loader />}

        <div className="pointer" style={{ width: "100%", padding: "20px" }}>
          <h2 style={{ color: "#888888" }}>OTA Crash Logs</h2>

          <table className="table">
            <thead
              className="tableHeaderColor"
              style={{ backgroundColor: "#f5f5f5" }}
            >
              <tr>
                <th style={styles.header}>S.No</th>
                <th style={styles.header}>Building ID</th>
                <th style={styles.header}>Created At</th>
                <th style={styles.header}>Logs Path</th>
              </tr>
            </thead>
            <tbody>
              {logsData.length > 0 ? (
                logsData.map((log, index) => (
                  <tr key={log.id || index}>
                    <td style={styles.cell}>{index + 1}</td>
                    <td style={styles.cell}>{log.building_id}</td>
                    <td style={styles.cell}>
                      {new Date(log.created_at).toLocaleString()}
                    </td>
                    <td style={styles.cell}>
                      <a
                        href={log.logs_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#1976d2",
                          textDecoration: "underline",
                        }}
                      >
                        {log.logs_path}
                      </a>
                    </td>

                    {/* <td style={styles.cell}>
                      <IconButton
                        onClick={() => this.downloadFile(log.logs_path)}
                        sx={{ color: '#2980B9' }}
                      >
                        <FileDownloadIcon />
                      </IconButton> */}
                    {/* </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={styles.cell} colSpan="5">
                    No OTA crash logs found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}

const styles = {
  header: {
    fontSize: "12px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "#000",
    fontWeight: "bold",
  },
  cell: {
    fontSize: "12px",
    textAlign: "center",
    verticalAlign: "middle",
    wordBreak: "break-word",
  },
};

const mapStateToProps = (state) => ({
  redux: state,
});

const mapDispatchToProps = (dispatch) => ({
  searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OtaCrashLogsList);
